<template>
	<el-dialog :close-on-click-modal="false" title="关联版式" :visible.sync="isShow" width="1100px">
		<el-form inline ref="form" :model="searchLayoutVo" label-width="100px">
			<el-form-item label="页面类型：">
				<el-select v-model="searchLayoutVo.pageTypeCode" disabled clearable placeholder="请选择">
					<el-option label="" value="">全部</el-option>
					<el-option v-for="item in $store.state.pms.pageTypeList" :key="item.id" :label="item.typeName" :value="item.typeCode"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="宽高：">
				<el-input v-model="searchLayoutVo.templateSize" placeholder="输入宽高" disabled></el-input>
			</el-form-item>
			<el-form-item label="模板性质：">
				<el-select clearable v-model="searchLayoutVo.propertyId" placeholder="请选择" disabled>
					<el-option v-for="item in propertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="创建日期：">
				<el-date-picker v-model="time" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" align="left" unlink-panels range-separator="至" start-placeholder="请选择开始日期"
					end-placeholder="请选择结束日期"></el-date-picker>
			</el-form-item>
			<el-form-item label="照片数量：">
				<el-input v-model="searchLayoutVo.imageCount" clearable placeholder="请输入图片数量"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button round @click="(queryInfo.pageNum = 1), onSubmit()">查询</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" ref="multipleTable" @selection-change="handleSelectionChange" border :row-key="getRowKey">
			<el-table-column type="selection" reserve-selection></el-table-column>
			<el-table-column label="编号" prop="id"></el-table-column>
			<el-table-column label="版式缩略图">
				<template slot-scope="scope">
					<el-image :src="scope.row.layoutThumbnail" :preview-src-list="[scope.row.layoutThumbnail]" fit="cover"></el-image>
				</template>
			</el-table-column>
			<el-table-column label="页面类型" prop="typeName"></el-table-column>
			<el-table-column label="模板性质" prop="propertyName"></el-table-column>
			<el-table-column label="照片数量" prop="imageCount"></el-table-column>
			<el-table-column label="宽高" prop="templateSize"></el-table-column>
			<el-table-column label="前端是否显示" prop="isShow" v-permission="'pts:admin:layout:setShow'">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.isShow" :active-value="1" :inactive-value="0" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)"></el-switch>
				</template>
			</el-table-column>
		</el-table>
		<v-pagination class="v-pagination" @changePage="changePage" :queryInfo="queryInfo"></v-pagination>
		<span slot="footer" class="dialog-footer">
			<el-button @click="isShow = false">取 消</el-button>
			<el-button type="primary" @click="associated">关 联</el-button>
		</span>
	</el-dialog>
</template>

<script>
import VPagination from '@/components/Pagination/index.vue'

import { layoutGetLayoutList, propertyGetPropertyList, templateGroupTemplateGroupRelateLayout } from '@/api/pms'

export default {
	components: { VPagination },
	data () {
		return {
			isShow: false,
			searchLayoutVo: {
				createTimeBegin: '',
				createTimeEnd: '',
				id: '',
				imageCount: '',
				page: 1,
				pageTypeCode: '',
				propertyId: '',
				templateSize: ''
			},
			time: [],
			tableData: [],
			propertyList: [],
			queryInfo: {
				pageNum: 1,
				pageSize: 10,
				total: 0
			},
			templateGroupId: '',
			multipleSelection: []
		}
	},
	watch: {
		time (val) {
			console.log(val, this.searchLayoutVo)
			this.searchLayoutVo.createTimeBegin = val === null ? '' : val[0]
			this.searchLayoutVo.createTimeEnd = val === null ? '' : val[1]
		}
	},
	created () {
		this.getPropertyName()
	},
	methods: {
		getRowKey (row) {
			return row.id
		},
		show (val) {
			this.templateGroupId = val.id
			this.isShow = true
			this.searchLayoutVo.templateSize = val.templateSize
			this.searchLayoutVo.propertyId = val.propertyId
			this.searchLayoutVo.pageTypeCode = val.pageTypeCode
			this.onSubmit()
		},
		associated () {
			console.log(this.multipleSelection)
			if (!this.multipleSelection.length) {
				this.$message.warning('请选择要关联的版式')
				return
			}
			let vo = {
				layoutXrefVos: [],
				templateGroupId: this.templateGroupId
			}
			this.multipleSelection.forEach(item => {
				vo.layoutXrefVos.push({
					isShow: item.isShow,
					layoutId: item.id
				})
			})
			templateGroupTemplateGroupRelateLayout(vo).then(res => {
				if (res.data.success) {
					this.$message.success('关联成功')
					this.isShow = false
					this.$emit('success')
				}
			})
		},
		onSubmit () {
			layoutGetLayoutList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchLayoutVo: this.searchLayoutVo }).then(res => {
				if (res.data.success) {
					if (res.data.data.records.length === 0 && res.data.data.total !== 0 && this.queryInfo.pageNum !== 1) {
						this.queryInfo.pageNum--
						this.onSubmit(this.queryInfo)
					}
					this.tableData = res.data.data.records
					this.queryInfo.total = res.data.data.total
				}
			})
		},
		// 获取模板性质管理
		getPropertyName () {
			propertyGetPropertyList().then(res => {
				if (res.data.success) {
					this.propertyList = res.data.data
				}
			})
		},
		handleSelectionChange (val) {
			this.multipleSelection = val
		},
		changePage (val) {
			this.queryInfo = val
			this.onSubmit()
		}
	}
}
</script>

<style>
</style>
